import { HttpInterceptorFn } from '@angular/common/http';

export const attachClientAppHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  const cloned = req.clone({
    setHeaders: {
      'X-Client-App': 'SlotClient'
    }
  });

  return next(cloned);
};
